import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./pages/Index";
export function ITAdminRoute() {
    return (
        <Routes>
            <Route index element={<IndexPage />} />
        </Routes>
    );
}
